import { useEffect } from 'react'
import useZustandStore from './useZustandStore'

export function useFont() {
  const fontFamily = useZustandStore(s => s.settings.fontFamily)

  useEffect(() => {
    document.documentElement.style.setProperty('--app-font-family', fontFamily)
  }, [fontFamily])

  return fontFamily
}
